var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty"},[_c('van-empty',{attrs:{"image":"https://account.kmmds.top/datainfo_pic/error.png","description":"暂无就诊卡信息"}}),_c('div',{staticClass:"emptyBtn"},[_c('van-button',{staticClass:"emptyBtn_text",attrs:{"color":"#5B8DF6","plain":"","size":"large","round":""},on:{"click":_vm.btnClick}},[_vm._v("立即绑卡")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }